import React from 'react'
import t from '~t'
import PickerFile from '~co/picker/file/element'

import { Button, Icon } from '~ui';

export default function PickerIconAdd(props) {
    return (
        <Button 
            as='label'
            variant='accent'
            title={t.s('uploadFile')}>
            <PickerFile {...props}>
                <Icon name='add' />
            </PickerFile>
        </Button>
    )
}